var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17.001,
    viewBox: "0 0 17 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-1.15 -1.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709",
    transform: "translate(1.15 1.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M14.236,18.513H3.428A2.28,2.28,0,0,1,1.15,16.236V5.428A2.28,2.28,0,0,1,3.428,3.15h5.4a.734.734,0,0,1,0,1.467h-5.4a.811.811,0,0,0-.81.81V16.236a.811.811,0,0,0,.81.81H14.236a.811.811,0,0,0,.81-.81v-5.4a.734.734,0,1,1,1.467,0v5.4A2.28,2.28,0,0,1,14.236,18.513Z",
    transform: "translate(-1.15 -1.512)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M17.148,1.029a2.371,2.371,0,0,1,1.677,4.048L11.49,12.411a.733.733,0,0,1-.341.193l-3.088.772a.734.734,0,0,1-.89-.89L7.944,9.4a.733.733,0,0,1,.193-.341l7.334-7.334A2.356,2.356,0,0,1,17.148,1.029ZM10.6,11.23l7.191-7.19a.9.9,0,1,0-1.279-1.279L9.318,9.951l-.426,1.7Z",
    transform: "translate(-2.518 -1.029)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditNote);
export default __webpack_public_path__ + "static/media/CreditNote.20364f132fbcdc30da89f87be6996bdf.svg";
export { ForwardRef as ReactComponent };